import React from "react";

export default function WebappUtility(props) {

	const x = props.x;
	const renderCount = React.useRef(1);
	const componentId = React.useRef(0);

	// Debug Infos
	let recentUrl = '';													// Wird über die Funktion getUrl gesetzt.

	React.useEffect(() => {
		if (renderCount.current === 1) {
			props.childRendered();
		}
		renderCount.current++;
	});


	x.wau.checkPaste = checkPaste;
	x.wau.ensureElementVisible = ensureElementVisible;
	x.wau.fillZero = fillZero;
	x.wau.getAttribute = getAttribute;
	x.wau.getComponentId = getComponentId;
	x.wau.getConversationalPartner = getConversationalPartner;
	x.wau.getId = getId;
	x.wau.getMembersDataAsMap = getMembersDataAsMap;
	x.wau.getPrivateForumId = getPrivateForumId;
	x.wau.getProperty = getProperty;
	x.wau.getStatus = getStatus;
	x.wau.getTime = getTime;
	x.wau.getUrl = getUrl;
	x.wau.nl2br = nl2br;
	x.wau.postingBackup = postingBackup;
	x.wau.postingBackupRemove = postingBackupRemove;
	x.wau.postingBackupsRemove = postingBackupsRemove;
	x.wau.postingRestore = postingRestore;
	x.wau.replaceChar = replaceChar;
	x.wau.setMembersData = setMembersData;
	x.wau.translatePosting = translatePosting;
	x.wau.validPassword = validPassword;
	x.wau.yesNo = yesNo;


	function getId(wafId, id) {
		return wafId + '-' + id;
	}
	function getStatus() {
		const current = new Date();
		const date = fillZero(current.getDate()) + '.' + fillZero((current.getMonth() + 1)) + '.' + current.getFullYear()
		const screen = document.body.clientWidth + 'px * ' + document.body.clientHeight + 'px';
		let localStorageKeys = '';
		let sessionStorageKeys = '';
		Object.keys(localStorage).forEach(function (key) {
			localStorageKeys += key + ': ' + localStorage.getItem(key) + '\n';
		});
		Object.keys(sessionStorage).forEach(function (key) {
			sessionStorageKeys += key + ': ' + sessionStorage.getItem(key) + '\n';
		});
		const status =
			"Enthält vertrauliche Informationen, nicht an Dritte weitergeben!!!\n\n" +
			"Applikation: " + x.was.application + '\n' +
			"Browser: " + navigator.userAgent + '\n' +
			"Webapp Version: " + x.was.version + ', Build ' + x.was.buildNo + '\n' +
			"React Version: " + React.version + '\n' +
			"jQuery Version: " + x.$().jquery + '\n\n' +
			"Screen: " + screen + '\n' +
			"Zuletzt verwendete URL: " + recentUrl + '\n\n' +
			"LocalStorage: \n" + localStorageKeys + '\n' +
			"SessionStorage: \n" + sessionStorageKeys + '\n' +
			"Erstellt am: " + date + ', ' + fillZero(current.getHours()) + ':' + fillZero(current.getMinutes()) + ':' + fillZero(current.getSeconds()) + ' Uhr ';
		return status;
	}

	/*
		Posting Functions
	*/

	function ensureElementVisible(container, element) {
		element.scrollIntoView({
			behavior: 'smooth', // Für eine sanfte Animation beim Scrollen
			block: 'nearest',    // Zentriert das Element vertikal
			inline: 'start'    // Zentriert das Element horizontal
		});
	}

	function postingBackup(wafId, postingNo, value) {
		// const storageId = ((props.answerTo === 0) ? '' : props.answerTo + '-') + wafId + '-' + postingId;
		sessionStorage.setItem(getStorageId(wafId, postingNo), value);
	}

	function postingBackupRemove(wafId, postingNo) {
		const storageId = getStorageId(wafId, postingNo);
		if (sessionStorage.getItem(storageId) !== null) {
			sessionStorage.removeItem(storageId);
		}
	}

	function postingRestore(wafId, postingNo) {
		const postingBackup = sessionStorage.getItem(getStorageId(wafId, postingNo));
		// console.log(postingBackup);
		if (postingBackup !== null) {
			x.waf.set(wafId, 'posting', postingBackup);
		}
		else {
			x.waf.set(wafId, 'posting', '');
		}
		return postingBackup;
	}

	function getStorageId(wafId, postingNo) {
		const storageId = postingNo.toString().padStart(10, '0') + '-' + wafId + '-posting';
		return storageId;
	}

	function postingBackupsRemove() {
		Object.keys(sessionStorage).forEach(function (key) {
			if (key !== 'token') {
				sessionStorage.removeItem(key);
			}
		});
	}

	function fillZero(value) {
		return (value < 10) ? '0' + value : value;
	}

	function getPrivateForumId(memberId) {
		if (memberId === 'forum') {
			return memberId
		}
		else {
			return (x.was.memberId > memberId) ? memberId + '-' + x.was.memberId : x.was.memberId + '-' + memberId;
		}
	}

	function checkPaste(text, newThread = true, openNewThread = () => { }) {
		const forumId = x.wam.getForumId();
		const wafId = forumId + '-' + ((newThread) ? 'new-thread' : 'answer');
		let rc = false;
		let newText = '';
		if (text !== "") {
			if (text.substr(0, 7) === 'http://' || text.substr(0, 8) === 'https://') {
				rc = true;
				x.was.setModal(true);
				const setPostingText = (text, cursorTop = false) => {
					openNewThread();
					// console.log(x.waf.get(wafId, 'posting'));
					const curPos = x.waf[wafId].elements['posting'].reference.current.selectionStart;
					const curVal = x.waf.get(wafId, 'posting');
					const leftValue = curVal.substring(0, curPos);
					const rightValue = curVal.substring(curPos);
					// x.waf.set(x.wad[props.id].wafId, 'posting', leftValue + '[' + tag + ']' + text + '[/' + tag + ']' + rightValue);
					// ((leftValue === '') ? '' : '\r\n') + 
					const newValue = leftValue + ((leftValue === '') ? '' : '\r\n') + text + rightValue;
					x.wau.postingBackup(wafId, 'posting', newValue);
					x.waf.set(wafId, 'posting', newValue);
					x.waf[wafId].enableSendButton(x.waf.checkChanged(wafId));
					x.was.setModal(false);
					if (cursorTop) {
						x.waf.set(wafId, 'posting', '\r\n' + newValue);
						x.waf[wafId].elements['posting'].reference.current.selectionStart = 0;
						x.waf[wafId].elements['posting'].reference.current.selectionEnd = 0;
					}
				}


				const checkUrl = (url) => {
					let image = new Image();
					image.onload = function () {
						console.log('Loaded: ' + text);
						// setPostingText('[img]' + text + '[/img]'+'\r\n');
						setPostingText(`[img]${text}[/img]`, true);
					}
					image.onerror = function () {
						const progressHint = x.wah.addHint('URL prüfen...', false);
						x.was.send('get-preview', { 'url': text }, (result) => {
							// console.log('Result: ' + result);
							x.wam.activate(forumId);
							newText = (result.title !== '') ? `"${result.title}"\r\n\n` : '';
							newText += `[url=${text}]${text}[/url]\r\n`;
							if (result.description !== '') {
								newText += '\r\n"' + result.description + '"\r\n';
							}
							if (result.image !== '') {
								newText += ' \r\n[img]' + result.image + '[/img]';
							}
							setPostingText(newText);
						});
						x.wah.removeHint(null, progressHint);
					}
					image.src = url;
				}
				checkUrl(text);
			}
		}
		return rc;
	}

	function getConversationalPartner(forumId) {
		if (forumId === 'forum') {
			return forumId;
		}
		else {
			const memberIds = forumId.split('-');
			if (parseInt(memberIds[0]) === x.was.memberId) {
				return memberIds[1];
			}
			else {
				return memberIds[0];
			}
			// console.log('Forum :' + forumId + ' - ' + ' MemberId: ' + memberId);
		}
	}

	function getMembersDataAsMap() {
		const map = new Map(setMembersData().map(item => [item.id, item]));
		return map;		
	}

	function setMembersData() {

		const sortMembers = (members) => {
			return members.sort(function (a, b) {
				let x = a.name.toLowerCase();
				let y = b.name.toLowerCase();
				if (x < y) { return -1; }
				if (x > y) { return 1; }
				return 0;
			});
		}

		const members = [];
		Object.entries(x.was.members).forEach(([key, value]) => {
			members.push({ "id": key, "name": value.name });
		});

		const sortedMembers = sortMembers(members);
		return sortedMembers;
	}

	function translatePosting(posting) {
		posting = nl2br(posting);
		posting = translateSmilies(posting);
		posting = translateBBCode(posting);
		posting = replaceMentions(posting, x.wau.setMembersData());

		return posting;
	}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function replaceMentions(text, members) {
  if (!text.includes("@")) return text;

  const mentionRegex = /@([^\s@]+)/g;
  let lastIndex = 0;
  let result = "";
  let match;

  while ((match = mentionRegex.exec(text)) !== null) {
    const startIndex = match.index;

    // Versuche, einen passenden Mitgliedsnamen zu finden
    let found = false;

    for (let i = 0; i < members.length; i++) {
      const { name, id } = members[i];

      // Prüfen, ob der Name direkt nach dem @ steht
      if (text.startsWith(name, startIndex + 1)) {
        // Text vor der Mention einfügen
        result += text.slice(lastIndex, startIndex);

        // Mention als Link einsetzen (kein inline-onclick: Browser dekodieren
        // HTML-Entities in Attributwerten, bevor der Inhalt als JS ausgeführt wird -
        // Escaping allein würde also kein Ausbrechen aus dem JS-String verhindern.
        // Stattdessen nur data-Attribute, Klick wird zentral per Event-Delegation behandelt.)
        const safeId = escapeHtml(id);
        const safeName = escapeHtml(name);
        result += `<a href="#" class="mention" data-memberid="${safeId}" data-membername="${safeName}">@${safeName}</a>`;

        lastIndex = startIndex + 1 + name.length;
        found = true;
        break;
      }
    }

    if (!found) {
      // Keine Übereinstimmung — Mention unverändert übernehmen
      result += text.slice(lastIndex, mentionRegex.lastIndex);
      lastIndex = mentionRegex.lastIndex;
    }
  }

  if (lastIndex < text.length) {
    result += text.slice(lastIndex);
  }

  return result;
}


	function translateSmilies(posting) {
		try {
			if (posting.search(':-') > -1) {
				Object.entries(x.was.smilies).forEach(([key, value]) => {
					posting = posting.replaceAll(':-' + key, value);
					if (posting.search(':-') === -1) {
						throw new Error("Break the loop.")
					}
				});
			}
		}
		catch (error) {

		}
		return posting;
	}

	function translateBBCode(posting) {
		posting = posting.replaceAll('[ul]', '<ul>');
		posting = posting.replaceAll('[/ul]', '</ul>');
		posting = posting.replaceAll('[li]', '<li>');
		posting = posting.replaceAll('[/li]', '</li>');
		posting = posting.replaceAll('[b]', '<b>');
		posting = posting.replaceAll('[/b]', '</b>');
		posting = posting.replaceAll('[i]', '<i>');
		posting = posting.replaceAll('[/i]', '</i>');
		posting = posting.replaceAll('[u]', '<span style="text-decoration:underline;">');
		posting = posting.replaceAll('[/u]', '</span>');
		posting = posting.replaceAll('[quote]', '<span class="posting-quote">');
		posting = posting.replaceAll('[/quote]', '</span>');
		posting = posting.replaceAll('[smiley]', '<span class="smiley" src="');
		posting = posting.replaceAll('[/smiley]', '"/>');
		posting = posting.replaceAll('[img]', '<img src="');
		posting = posting.replaceAll('[/img]', '"/>');
		posting = translateBBCodeUrl(posting);
		return posting;

	}

	function translateBBCodeUrl(posting) {
		let newPosting = posting.replaceAll('[url=', '<a target="_blank" rel="nofollow ugc noopener" href="');
		let closeTagPos = newPosting.indexOf('[/url]');
		let curPos;
		while (closeTagPos > -1) {
			curPos = closeTagPos - 1;
			while (curPos > -1) {
				if (newPosting[curPos] === ']') {
					newPosting = newPosting.replace('[/url]', '</a>');
					newPosting = x.wau.replaceChar(newPosting, '">', curPos);
					break;
				}
				curPos--;
			}
			closeTagPos = newPosting.indexOf('[/url]', closeTagPos + 1);
			// console.log('closeTagPos: ' + closeTagPos);
		}
		// newPosting = newPosting.replaceAll('[/url]', '</a>');
		return newPosting;
	}


	function nl2br(str) {
		if (str.indexOf('<br />') === -1) {
			var breakTag = '<br />';
			var replaceStr = '$1' + breakTag;
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
		}
		else {
			return str;
		}
	}

	function replaceChar(origString, replaceChar, index) {
		let firstPart = origString.substr(0, index);
		let lastPart = origString.substr(index + 1);

		let newString = firstPart + replaceChar + lastPart;
		return newString;
	}

	function getTime(date) {
		if (date === undefined) {
			date = new Date();
		}
		let time = (date.getHours() < 10 ? '0' : '') + date.getHours() + ':';
		time += (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ':';
		time += (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
		return (time);
	}

	function getAttribute(e, attribute, defaultValue) {
		if (e.target.attributes.getNamedItem(attribute) === null) {
			return defaultValue;
		}
		else {
			return (typeof e.target.attributes.getNamedItem(attribute) === 'undefined') ? defaultValue : e.target.attributes.getNamedItem(attribute).value;
		}
	}

	function getProperty(property, defaultValue) {
		return (typeof property === 'undefined') ? defaultValue : property;
	}

	function getUrl(url) {
		// const location = document.location.href;
		const delimiter = (url[0] !== '/') ? '/' : '';
		url = delimiter + url;
		recentUrl = url;
		return url;
	}

	function getComponentId() {
		componentId.current++;
		return componentId.current;
	}

	function validPassword(newPassword, oldPassword = false) {
		if (oldPassword === false || newPassword !== oldPassword) {
			if (newPassword.length > 7 && newPassword.length < 21 && newPassword.search(/[a-z]/) > -1 && newPassword.search(/[A-Z]/) > -1 && newPassword.search(/[0-9]/) > -1) {
				return true;
			}
		}
		return false;
	}

	function yesNo(question, handleAnswer) {
		x.wad['yesno'].setTitle(question);
		x.wad['yesno'].onClose = handleAnswer;
		x.wad['yesno'].show();
	}

	return (
		<React.Fragment >
		</React.Fragment>
	);

}

